import * as Api from '@ViewModels';
import * as React from 'react';
import { EStatusOption, StatusFilterCheckboxesMap, findMatchingStatus } from './statusFilterOptions';

export { EStatusOption, StatusFilterCheckboxesMap };

export const useStatusFilters = (initialFilterCriteria: Api.IContactFilterCriteria[] = []) => {
	const getInitialValues = (criteria: Api.IContactFilterCriteria[]) => {
		return criteria
			.map(criterion => {
				const match = findMatchingStatus(criterion);
				return match ? (parseInt(match[0], 10) as EStatusOption) : undefined;
			})
			.filter(x => x !== undefined) as EStatusOption[];
	};

	const [selectedStatuses, setSelectedStatuses] = React.useState<EStatusOption[]>(
		getInitialValues(initialFilterCriteria)
	);

	const getStatusCriteria = () => {
		return selectedStatuses.map(statusOption => StatusFilterCheckboxesMap[statusOption].criteria);
	};

	const refreshStatuses = (criteria: Api.IContactFilterCriteria[]) => {
		setSelectedStatuses(getInitialValues(criteria));
	};

	return {
		findMatchingStatus,
		getStatusCriteria,
		selectedStatuses,
		setSelectedStatuses,
		refreshStatuses,
	};
};
